import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-17c00e5c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "http://www.computerinfor.nl",
  target: "_blank"
}, "ComputerInfor", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " MaatComputers doet vrijwel alles wat met computers te maken heeft: vervaardiging, revisie, onderhoud, aansluiting, advies, verkoop en nog veel meer. U kunt hier terecht voor al uw computergerelateerde problemen. ", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Open communicatie, heldere afspraken en 100% klanttevredenheid is het streven van MaatComputers. Laat uzelf overtuigen en maak een afspraak! ", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Al sinds 2014 is ComputerInfor het juiste adres voor vervaardiging, reparatie en onderhoud van computers. In 2019 zijn de werkzaamheden uitgebreid met de ontwikkeling van software applicaties. ", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Om het aanbod van diensten overzichtelijk te houden, is in 2021 de onderneming onderverdeeld in twee dochterondernemingen: MaatComputers en MaatAutomatisering. ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_header_layout = _resolveComponent("header-layout")!
  const _component_banner_layout = _resolveComponent("banner-layout")!
  const _component_notice_alert = _resolveComponent("notice-alert")!
  const _component_single_block = _resolveComponent("single-block")!
  const _component_quadruple_block = _resolveComponent("quadruple-block")!
  const _component_footer_layout = _resolveComponent("footer-layout")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_header_layout, {
      displayBreadcrumb: false,
      displaySearchForm: false
    }),
    _createVNode(_component_banner_layout, {
      slogan: "Computers op maat",
      subtitle: "MaatComputers"
    }),
    _createElementVNode("section", null, [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_single_block, null, {
          default: _withCtx(() => [
            _createVNode(_component_notice_alert, null, {
              default: _withCtx(() => [
                _createTextVNode(" MaatComputers is een dochteronderneming van "),
                _hoisted_2,
                _createTextVNode(". ")
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_quadruple_block, null, {
          default: _withCtx(() => [
            _hoisted_3
          ]),
          _: 1
        }),
        _createVNode(_component_quadruple_block, null, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        }),
        _createVNode(_component_quadruple_block, null, {
          default: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        }),
        _createVNode(_component_quadruple_block, null, {
          default: _withCtx(() => [
            _hoisted_6
          ]),
          _: 1
        })
      ])
    ]),
    _createVNode(_component_banner_layout, {
      class: "banner",
      backgroundImage: $data.onderhoudImage
    }, null, 8, ["backgroundImage"]),
    _createVNode(_component_footer_layout)
  ], 64))
}